import React from 'react';
import { Button, ButtonGroup, FormLabel } from 'react-bootstrap';
import { GameOutcome } from '../types/GameOutcome';
import { useAppDispatch, useAppSelector } from '../store';
import { setParams } from '../reducers/paramsReducer';

export default function GamesFiltersResult(): React.ReactNode {
  const { result } = useAppSelector((state) => state.paramsReducer.params);
  const dispatch = useAppDispatch();

  const go = (r?: GameOutcome) => {
    if (r != result) {
      dispatch(setParams({ result: r ?? null }));
    }
  };

  return (
    <>
      <FormLabel className="d-block">Result</FormLabel>
      <ButtonGroup className="cm-segmented">
        <Button variant="outline-primary" active={result == null} onClick={() => go()}>
          Both
        </Button>
        <Button
          variant="outline-primary"
          active={result == GameOutcome.Won}
          onClick={() => go(GameOutcome.Won)}
        >
          Won
        </Button>
        <Button
          variant="outline-primary"
          active={result == GameOutcome.Lost}
          onClick={() => go(GameOutcome.Lost)}
        >
          Lost
        </Button>
      </ButtonGroup>
    </>
  );
}
